module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAOtJREFUWEftlk0KwjAQhV9Kz+EBbHoHL+EdXLp0Z71OcelSUMGtdDPxEt6hkVkEQqg0P4siTJctyfv65QVGYeFHLZwPASg2oLW+AXgQUZdznAIgBsSAGBADYkAMiIH/MqC17sLJZ2oiatt2W9f1fRiGz9yUFG2gaZp1VVX9OI4XY8zBbRwCcLi1tgdwihnTogE40EFYa69EtOd3PkBqOK9PAgggnkS0cwBKKZPy585gMkAA8QKw4qkYwDFWu9+LLIAAgou2yQnPOgKf3uvEOaZwUzci24DbjCGMMe+56/brezFAbnBRCUtD/fVfWvzDIX2dtRcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/down.png
// module id = AUq9
// module chunks = 0